import { render, staticRenderFns } from "./horizons-agreement.vue?vue&type=template&id=337bb7cf&scoped=true&"
import script from "./horizons-agreement.vue?vue&type=script&lang=js&"
export * from "./horizons-agreement.vue?vue&type=script&lang=js&"
import style0 from "./horizons-agreement.vue?vue&type=style&index=0&id=337bb7cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337bb7cf",
  null
  
)

export default component.exports